// Crops a product PNG to its green artwork so the artwork edges sit exactly on the frame edges.
// The zoom then scales the screenshot inside a static green panel, the same as the landing page.
export const artworkCrop = (
  imageWidth: number,
  imageHeight: number,
  artworkX: number,
  artworkY: number,
  artworkWidth: number,
  artworkHeight: number,
) => ({
  aspectRatio: artworkWidth / artworkHeight,
  imageProps: {
    w: `${(imageWidth / artworkWidth) * 100}%`,
    left: `-${(artworkX / artworkWidth) * 100}%`,
    top: `-${(artworkY / artworkHeight) * 100}%`,
  },
});
